import { render, staticRenderFns } from "./TrainingLecture.vue?vue&type=template&id=27ff13b0&"
import script from "./TrainingLecture.vue?vue&type=script&lang=js&"
export * from "./TrainingLecture.vue?vue&type=script&lang=js&"
import style0 from "./TrainingLecture.vue?vue&type=style&index=0&id=27ff13b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports